import React from 'react';
import { navigate } from '@gatsbyjs/reach-router';
import { CardConfirmed } from '..';
import { MainLayout } from '../../../../../../hoc/components/layout/layout';
import CloseButton from '../../../../../../hoc/components/modal/close-button';
import { FlowRouteProps } from '../../../../../flow/flow';
import useTranslation from '../../../../../../../hooks/useTranslation';

function Print({ location }: FlowRouteProps) {
	const { t } = useTranslation();

	return (
		<MainLayout label={t('pages.print.label')} header={false} footer={false}>
			<div className="relative max-w-6xl mx-auto pt-28 lg:pt-20 pb-20 print:py-0 text-font">
				<div className="absolute top-0 right-0 p-6 lg:p-9 print:hidden">
					<CloseButton
						onClose={() => {
							navigate(-1);
						}}
					/>
				</div>
				<div className="max-w-4xl mx-auto px-6 lg:px-0">
					<CardConfirmed
						status={location?.state.status}
						service={location?.state.service}
						data={location?.state.data}
						printMode={true}
					/>
				</div>
			</div>
		</MainLayout>
	);
}

export default Print;
